import { ThemeProvider, Typography } from '@mui/material';
import '../Styles/CategoryStyles.css';

import CouponList from '../Statefull/CouponList';
import { theme } from '../../theme';

const ManageCoupon = () => {
  const handleEditCategory = () => {
    // Handle edit category logic
  };

  return (
    <ThemeProvider theme={theme}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Manage Coupon
      </Typography>

      <CouponList editCategory={handleEditCategory} addCoupon={handleEditCategory} />
    </ThemeProvider>
  );
};

export default ManageCoupon;
